// extracted by mini-css-extract-plugin
export default {"button":"styles_button__X0--3","withUnderLine":"styles_withUnderLine__NSVLJ","text":"styles_text__wnxkR"};